import React, { Component } from 'react'
import { MessageListTheme } from '../../../modules/theme'

export class MessageList extends Component {
  render() {
    return (
      <MessageListTheme 
        userImg={'images/Profile.png'}
        sign={'active'}
        name={'Olivia Williams'}
        number={'+91 78 456 7894'}
        btnSend={'images/sent.svg'}
      />
    )
  }
}

export default MessageList


// WEBPACK FOOTER //
// src/dialpad/components/layout/MessageList.js